const SET_PRESETS = (state, presets) => {
  state.presets = presets
}

const ADD_PRESET = (state, preset) => {
  state.presets.push(preset)
}

const DELETE_PRESET = (state, id) => {
  state.presets = state.presets.filter(s => s.id !== id)
}

const EDIT_PRESET = (state, preset) => {
  state.presets = state.presets.map(s => {
    if (s.id === preset.id) {
      return preset
    } else {
      return s
    }
  })
}

const IS_LOADED = state => {
  state.isLoaded = true
}

export default {
  ADD_PRESET,
  DELETE_PRESET,
  EDIT_PRESET,
  SET_PRESETS,
  IS_LOADED
}
